import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Notifications from '../Notifications/Notifications';
import SearchModal from '../SearchModal/SearchModal';
import './Header.css';

const Header = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
  
  const userDropdownRef = useRef(null);
  const userAvatarRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target) && 
          userAvatarRef.current && !userAvatarRef.current.contains(event.target)) {
        setIsUserDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Handle keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.preventDefault();
        setIsSearchOpen(true);
      }
      if (event.key === 'Escape') {
        if (isSearchOpen) {
          setIsSearchOpen(false);
        }
        if (isUserDropdownOpen) {
          setIsUserDropdownOpen(false);
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isSearchOpen, isUserDropdownOpen]);

  // Listen for sidebar state changes to sync the mobile menu icon
  useEffect(() => {
    const handleSidebarStateChange = (event) => {
      setIsMobileMenuOpen(event.detail.isOpen);
    };

    document.addEventListener('sidebarStateChanged', handleSidebarStateChange);
    return () => document.removeEventListener('sidebarStateChanged', handleSidebarStateChange);
  }, []);

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  const toggleSidebar = () => {
    // Dispatch custom event for sidebar toggle
    document.dispatchEvent(new CustomEvent('toggleSidebar'));
  };

  const toggleNotifications = () => {
    setIsNotificationsOpen(!isNotificationsOpen);
  };

  const closeNotifications = () => {
    setIsNotificationsOpen(false);
  };

  const openSearch = () => {
    setIsSearchOpen(true);
  };

  const closeSearch = () => {
    setIsSearchOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-content">
          <Link to="/dashboard" className="navbar-brand">
            <div className="navbar-brand-icon">
              <i className="fas fa-rocket"></i>
            </div>
            ProjectFlow
          </Link>
          
          <div className="header-actions">
            <button className="action-icon" title="Search" aria-label="Search" onClick={openSearch}>
              <i className="fas fa-search"></i>
            </button>
            <button className="action-icon" title="Notifications" aria-label="Notifications" onClick={toggleNotifications}>
              <i className="fas fa-bell"></i>
              <span className="badge">6</span>
            </button>
            <div className="user-profile">
              <img 
                ref={userAvatarRef}
                src="https://randomuser.me/api/portraits/men/32.jpg" 
                alt="User Profile" 
                className="user-avatar-img" 
                onClick={toggleUserDropdown}
              />
              <div ref={userDropdownRef} className={`user-dropdown ${isUserDropdownOpen ? 'show' : ''}`}>
                <div className="dropdown-header">
                  <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="User Profile" className="user-avatar-img" />
                  <div className="dropdown-username">
                    Cody Fisher
                    <span className="badge-pro">Pro</span>
                  </div>
                  <div className="dropdown-email">c.fisher@gmail.com</div>
                </div>
                <div className="dropdown-content">
                  <button className="dropdown-item-custom" type="button">
                    <i className="fas fa-user"></i> My Profile
                  </button>
                  <button className="dropdown-item-custom" type="button">
                    <i className="fas fa-cog"></i> Account Settings
                  </button>
                  <div className="dropdown-divider"></div>
                  <button className="dropdown-logout-btn" type="button">
                    <i className="fas fa-sign-out-alt"></i> Log out
                  </button>
                </div>
              </div>
            </div>
            <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle sidebar navigation">
              <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
            </button>
          </div>
        </div>
      </header>

      {/* Search Modal Component */}
      <SearchModal isOpen={isSearchOpen} onClose={closeSearch} />

      {/* Notifications Component */}
      <Notifications isOpen={isNotificationsOpen} onClose={closeNotifications} />
    </>
  );
};

export default Header;
